export const RESET_STATE = "@rooms/RESET_STATE";
export const SET_ERROR = "@rooms/SET_ERROR";

export const GET_ROOM_REQUEST = "@rooms/GET_ROOM_REQUEST";
export const GET_ROOM_SUCCESS = "@rooms/GET_ROOM_SUCCESS";
export const GET_ROOM_FAILURE = "@rooms/GET_ROOM_FAILURE";

export const UPDATE_ROOM_REQUEST = "@rooms/UPDATE_ROOM_REQUEST";
export const UPDATE_ROOM_SUCCESS = "@rooms/UPDATE_ROOM_SUCCESS";
export const UPDATE_ROOM_FAILURE = "@rooms/UPDATE_ROOM_FAILURE";

export const SELECT_ROOM_REQUEST = "@rooms/SELECT_ROOM_REQUEST";
export const SELECT_ROOM_SUCCESS = "@rooms/SELECT_ROOM_SUCCESS";
export const SELECT_ROOM_FAILURE = "@rooms/SELECT_ROOM_FAILURE";

export const CREATE_ROOM_REQUEST = "@rooms/CREATE_ROOM_REQUEST";
export const CREATE_ROOM_SUCCESS = "@rooms/CREATE_ROOM_SUCCESS";
export const CREATE_ROOM_FAILURE = "@rooms/CREATE_ROOM_FAILURE";